// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3AOrU4","modalContent":"_4U80XO","content":"_2V43IM","title":"_1B1oUL","countdown":"_s4C7T","hint":"Et7uuX","button":"ZVPR_W"};